/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Box_Score_EmptyInputs */

const th_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีผู้เล่นในทั้งสองทีมในวันที่แข่งขันนี้`)
};

const en_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No players were on either squad on this game’s date.`)
};

const ja_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この試合の日付では、両チームに登録選手がいません。`)
};

const zh_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛当天两队阵容中都没有人。`)
};

const es_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún jugador estaba en ninguna de las plantillas en la fecha de este partido.`)
};

const pt_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogador estava nos elencos na data deste jogo.`)
};

const id_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada seorang pun di kedua skuad pada hari pertandingan.`)
};

const fr_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun joueur n’était dans l’un des deux effectifs à la date de ce match.`)
};

const tl_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nasa alinmang squad noong araw ng laro.`)
};

const vi_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày thi đấu không ai có trong hai đội hình.`)
};

const ko_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 당일 양 팀 선수단에 아무도 없었습니다.`)
};

const de_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Spieltag stand niemand in einem der beiden Kader.`)
};

const ru_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В день матча ни один из составов не был заполнен.`)
};

const tr_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maç günü iki kadroda da kimse yoktu.`)
};

const it_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il giorno della partita non c'era nessuno in nessuna delle due rose.`)
};

const pl_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W dniu meczu w żadnym ze składów nikogo nie było.`)
};

const uk_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У день матчу в жодному зі складів нікого не було.`)
};

const hi_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच के दिन दोनों में से किसी टीम में कोई नहीं था।`)
};

const ar_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يكن أحد في أي من التشكيلتين يوم المباراة.`)
};

const ms_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pada hari perlawanan tiada sesiapa dalam kedua-dua skuad.`)
};

const bn_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলার দিন দুই দলের কোনওটিতেই কেউ ছিল না।`)
};

const zh_tw2_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比賽當天兩隊名單中都沒有人。`)
};

const zh_hk2_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比賽當天兩隊名單中都沒有人。`)
};

const ur_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ کے دن دونوں میں سے کسی اسکواڈ میں کوئی نہیں تھا۔`)
};

const fa_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روز بازی در هیچ‌یک از دو فهرست تیم کسی نبود.`)
};

const sw_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siku ya mchezo hakukuwa na mtu kwenye vikosi vyote viwili.`)
};

const nl_game_box_score_empty = /** @type {(inputs: Game_Box_Score_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op de wedstrijddag zat er in geen van beide selecties iemand.`)
};

/**
* | output |
* | --- |
* | "No players were on either squad on this game’s date." |
*
* @param {Game_Box_Score_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const game_box_score_empty = /** @type {((inputs?: Game_Box_Score_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Box_Score_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_game_box_score_empty(inputs)
	if (locale === "ja") return ja_game_box_score_empty(inputs)
	if (locale === "zh") return zh_game_box_score_empty(inputs)
	if (locale === "es") return es_game_box_score_empty(inputs)
	if (locale === "pt") return pt_game_box_score_empty(inputs)
	if (locale === "id") return id_game_box_score_empty(inputs)
	if (locale === "fr") return fr_game_box_score_empty(inputs)
	if (locale === "tl") return tl_game_box_score_empty(inputs)
	if (locale === "vi") return vi_game_box_score_empty(inputs)
	if (locale === "ko") return ko_game_box_score_empty(inputs)
	if (locale === "de") return de_game_box_score_empty(inputs)
	if (locale === "ru") return ru_game_box_score_empty(inputs)
	if (locale === "tr") return tr_game_box_score_empty(inputs)
	if (locale === "it") return it_game_box_score_empty(inputs)
	if (locale === "pl") return pl_game_box_score_empty(inputs)
	if (locale === "uk") return uk_game_box_score_empty(inputs)
	if (locale === "hi") return hi_game_box_score_empty(inputs)
	if (locale === "ar") return ar_game_box_score_empty(inputs)
	if (locale === "ms") return ms_game_box_score_empty(inputs)
	if (locale === "bn") return bn_game_box_score_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_game_box_score_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_game_box_score_empty(inputs)
	if (locale === "ur") return ur_game_box_score_empty(inputs)
	if (locale === "fa") return fa_game_box_score_empty(inputs)
	if (locale === "sw") return sw_game_box_score_empty(inputs)
	if (locale === "nl") return nl_game_box_score_empty(inputs)
	return en_game_box_score_empty(inputs)
});